import dep0 from './aspect-square.tw.css.js';
import dep1 from './components.tw.css.js';
import dep2 from './hide-scrollbar.tw.css.js';
import dep3 from './link-style.tw.css.js';
import dep4 from './set-font-size.tw.css.js';
const css = ``;

    const allCss = [...dep0, ...dep1, ...dep2, ...dep3, ...dep4, css];
    export default allCss;
    